import Vue from 'vue'
import Router from 'vue-router'
import Search from '../pages/search/router'
import Home from '../pages/home/router'
import Login from '../pages/login/router'
import Register from '../pages/register/router'
import Project from '../pages/project/router'
import Error from '../pages/error/router'
import Question from '../pages/question/router'
import Biblio from '../pages/biblio/router'
import Mailing from '../pages/mailing/router'
import ReceiveQuestion from '../pages/receiveQuestion/router'
import ChatSolution from '../pages/chatSolution/router'
import Users from '../pages/users/router'
import ManageUsers from '../pages/manageUsers/router'
import ManageProfiles from '../pages/manageProfiles/router'
import Notifications from '../pages/notification/router'
import EditData from '../pages/editData/router'
import Stats from '../pages/stats/router'
import Plan from '../pages/plan/router'
import Expert from '../pages/expert/router'
import FollowSearch from '../pages/follow/router'
import Company from '../pages/company/router'
import TimestampFiles from '../pages/timestampFiles/router'
import Document from '../pages/document/router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    ...Login,
    ...Register,
    ...Home,
    ...Project,
    ...Search,
    ...Question,
    ...Biblio,
    ...Mailing,
    ...ReceiveQuestion,
    ...ChatSolution,
    ...Users,
    ...Company,
    ...TimestampFiles,
    ...ManageUsers,
    ...ManageProfiles,
    ...Notifications,
    ...EditData,
    ...Stats,
    ...Expert,
    ...Plan,
    ...FollowSearch,
    ...Document,
    ...Error
  ]
})

router.beforeEach((to, from, next) => {
  let tmp = to.meta.auth

  if (typeof to.meta.auth !== 'undefined' && to.meta.auth !== false) {
    if (!localStorage.getItem('default_auth_token') && localStorage.getItem('is_already_connect') !== 'true' &&
      window.location.origin.indexOf(process.env.SE_URL) === -1) {
      to.meta.auth = {
        redirect: '/user/register'
      }
    }
  }

  next()

  to.meta.auth = tmp
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js